// IANA time zones for the profile time-zone picker.
//
// Modern browsers expose the full canonical list via
// `Intl.supportedValuesOf('timeZone')`. We use it when available and fall back
// to a representative static list otherwise, so the dropdown always has data.

const FALLBACK_TIMEZONES = [
  'UTC',
  'Asia/Dubai', 'Asia/Kolkata', 'Asia/Karachi', 'Asia/Singapore', 'Asia/Tokyo',
  'Asia/Shanghai', 'Asia/Hong_Kong', 'Asia/Riyadh', 'Asia/Jerusalem',
  'Europe/London', 'Europe/Paris', 'Europe/Berlin', 'Europe/Madrid',
  'Europe/Moscow', 'Europe/Istanbul', 'Europe/Amsterdam', 'Europe/Zurich',
  'America/New_York', 'America/Chicago', 'America/Denver', 'America/Los_Angeles',
  'America/Sao_Paulo', 'America/Toronto', 'America/Mexico_City',
  'Africa/Cairo', 'Africa/Johannesburg', 'Africa/Lagos', 'Africa/Nairobi',
  'Australia/Sydney', 'Australia/Perth', 'Pacific/Auckland',
];

export function getTimeZones() {
  try {
    if (typeof Intl !== 'undefined' && typeof Intl.supportedValuesOf === 'function') {
      const tzs = Intl.supportedValuesOf('timeZone');
      if (Array.isArray(tzs) && tzs.length) return tzs;
    }
  } catch (e) { /* fall through to the static list */ }
  return FALLBACK_TIMEZONES;
}

// The browser's current guess, used as a sensible default when none is saved.
export function guessTimeZone() {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || '';
  } catch (e) {
    return '';
  }
}
